export default __webpack_public_path__ + "static/media/Game 1 The gold mine treasure map.25982428.png";